export default "6bc5d1786bc934a4ead38a0748906172.svg";